import * as $ from 'jquery';
import * as app from "CMS/core/application";
import News from 'AWFNews/Data/Entities/News';
import NewsTag from 'AWFNews/Data/Entities/NewsTag';
import Criteria from 'AWFNews/Data/Entities/Criteria';

export default class NewsRepository {

    private BASE_URL = '';
    public readonly NEWSLIST: string;

    constructor() {
        this.BASE_URL = app.formatLocationUrl('~/news/api/news');
        this.NEWSLIST = app.formatLocationUrl(this.BASE_URL + '/getAllOverview')
    }

    public get(id: string): Promise<News> {
        return new Promise<News>((resolve, reject) => {
            const $get = $.get(this.BASE_URL + '/get/' + id);
            $get.then((data) => {
                resolve(NewsRepository.mapNews(data));
            }, (e) => {
                reject(e);
            });
        });
    }

    public getAll(): Promise<Array<News>> {
        return new Promise<Array<News>>((resolve, reject) => {
            const $get = $.get(this.BASE_URL + '/getall');
            $get.then((datas) => {
                const result = new Array<News>();
                for (const data of datas) {
                    result.push(NewsRepository.mapNews(data));
                }
                resolve(result);
            }, (e) => {
                reject(e);
            });
        });
    }

    public getAllOverview(): Promise<Array<News>> {
        return new Promise<Array<News>>((resolve, reject) => {
            const $get = $.get(this.NEWSLIST);
            $get.then((datas) => {
                const result = new Array<News>();
                for (const data of datas) {
                    result.push(NewsRepository.mapNews(data));
                }
                resolve(result);
            }, (e) => {
                reject(e);
            });
        });
    }

    public getAllForCriteria(criteria: Criteria): Promise<Array<News>> {
        return new Promise<Array<News>>((resolve, reject) => {
            const $post = $.post({ url: this.BASE_URL + '/getallforcriteria', data: JSON.stringify(criteria), contentType: 'application/json' });
            $post.then((datas) => {
                const result = new Array<News>();
                for (const data of datas) {
                    result.push(NewsRepository.mapNews(data));
                }
                resolve(result);
            }, (e) => {
                reject(e);
            });
        });
    }

    public getCategories(): Promise<Array<string>> {
        return new Promise<Array<string>>((resolve, reject) => {
            const $get = $.get(this.BASE_URL + '/getcategories');
            $get.then((datas) => {
                const result = new Array<string>();
                for (const data of datas) {
                    result.push(data);
                }
                resolve(result);
            }, (e) => {
                reject(e);
            });
        });
    }

    public publish(id: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const $post = $.post({ url: this.BASE_URL + '/publish', data: JSON.stringify(id), contentType: 'application/json' });
            $post.then((data) => resolve(data), (e) => reject(e));
        });
    }

    public archive(id: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const $post = $.post({ url: this.BASE_URL + '/archive', data: JSON.stringify(id), contentType: 'application/json' });
            $post.then((data) => resolve(data), (e) => reject(e));
        });
    }

    public delete(id: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const $post = $.post({ url: this.BASE_URL + '/delete', data: JSON.stringify(id), contentType: 'application/json' });
            $post.then((data) => resolve(data), (e) => reject(e));
        });
    }

    public save(news: News): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const $post = $.post({ url: this.BASE_URL + '/save', data: JSON.stringify(news), contentType: 'application/json' });
            $post.then((data) => resolve(data), (e) => reject(e));
        });
    }

    public static mapNews(item: any): News {
        const news = new News();
        news.id = item.id;
        news.languageCode = item.languageCode;
        news.headline = item.headline;
        news.headlineThumb = item.headlineThumb;
        news.intro = item.intro;
        news.message = item.message;
        news.startDate = item.startDate != null ? new Date(item.startDate) : null;
        news.endDate = item.endDate != null ? new Date(item.endDate) : null;
        news.newsOrder = item.newsOrder;
        news.newsOrderMessage = item.newsOrderMessage,
        news.newsTimeStamp = new Date(item.newsTimeStamp);
        news.who = item.who;
        news.status = item.status;
        news.category = item.category;

        if (item.tags) {
            for (const tag of item.tags) {
                const newsTag = new NewsTag();
                newsTag.category = tag.category;
                newsTag.title = tag.title;
                newsTag.id = `${tag.category}.${tag.title}`;
                news.tags.push(newsTag);
                news.tagIds.push(newsTag.id);
            }
        }
        return news;
    }
}